import Sales from "./routes/Sales/Sales.vue";
import Trends from "./routes/Trends/Trends.vue";
import ActivityUser from "./routes/ActivityUser/ActivityUser.vue";
import ActivityShipment from "./routes/ActivityShipment/ActivityShipment.vue";

const salesDashboardRoutes = [
  {
    path: "sales",
    name: "Sales",
    component: Sales,
  },
  {
    path: "trends",
    name: "Trends",
    component: Trends,
  },
  {
    path: "activity-user",
    name: "Activity-User",
    component: ActivityUser,
  },
  // {
  //   path: "activity-shipment",
  //   name: "Activity-Shipment",
  //   component: ActivityShipment,
  // },
];

export default salesDashboardRoutes;
